import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Text_Decoration = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">✨ CSS Text Decoration</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>text-decoration</code> property in CSS is used to add, remove,
        or style decorations like <strong>underline</strong>,{" "}
        <strong>overline</strong>, <strong>line-through</strong>, and{" "}
        <strong>none</strong>. It can also define the <strong>style</strong>{" "}
        (solid, dotted, wavy) and <strong>color</strong>.
      </p>

      {/* Underline */}
      <div className="tutorial-section">
        <h2 className="section-title">Underline</h2>
        <p>Adds a line below the text.</p>
        <CodeCopyBlock
          code={`p {
  text-decoration: underline;
}`}
        />
        <p style={{ textDecoration: "underline" }}>This text is underlined</p>
      </div>

      {/* Overline */}
      <div className="tutorial-section">
        <h2 className="section-title">Overline</h2>
        <p>Adds a line above the text.</p>
        <CodeCopyBlock
          code={`h2 {
  text-decoration: overline;
}`}
        />
        <h2 style={{ textDecoration: "overline" }}>
          This text has an overline
        </h2>
      </div>

      {/* Line-through */}
      <div className="tutorial-section">
        <h2 className="section-title">Line-through</h2>
        <p>Draws a line through the text (strikethrough effect).</p>
        <CodeCopyBlock
          code={`span {
  text-decoration: line-through;
}`}
        />
        <span style={{ textDecoration: "line-through" }}>
          This text has a line through it
        </span>
      </div>

      {/* None */}
      <div className="tutorial-section">
        <h2 className="section-title">None</h2>
        <p>Removes all text decorations (useful for links).</p>
        <CodeCopyBlock
          code={`a {
  text-decoration: none;
  color: blue;
}`}
        />
        <a href="/" style={{ textDecoration: "none", color: "blue" }}>
          This is a link without underline
        </a>
      </div>

      {/* Decoration Style */}
      <div className="tutorial-section">
        <h2 className="section-title">Decoration Style</h2>
        <p>
          You can change how the line looks with values like <code>solid</code>,{" "}
          <code>dotted</code>, <code>dashed</code>, <code>wavy</code>.
        </p>
        <CodeCopyBlock
          code={`p {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: red;
}`}
        />
        <p
          style={{
            textDecorationLine: "underline",
            textDecorationStyle: "wavy",
            textDecorationColor: "red",
          }}
        >
          This is a wavy red underline
        </p>
      </div>

      {/* Shorthand */}
      <div className="tutorial-section">
        <h2 className="section-title">Shorthand Usage</h2>
        <p>
          You can combine <strong>line</strong>, <strong>style</strong>, and{" "}
          <strong>color</strong> in one shorthand declaration.
        </p>
        <CodeCopyBlock
          code={`h3 {
  text-decoration: underline wavy green;
}`}
        />
        <h3 style={{ textDecoration: "underline wavy green" }}>
          This is shorthand decoration
        </h3>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After text decoration, you can explore{" "}
          <a href="/css/text-transformation" className="learn-more">
            CSS Text Transformation
          </a>{" "}
          to change text case (uppercase, lowercase, capitalize).
        </p>
      </div>
    </div>
  );
};

export default Text_Decoration;
